import { Date } from 'hb-react/shared/components/formik/components/inputs';

export const StartDate = () => (
  <Date
    label={s__('JobForm|Start date')}
    name="start_date"
    placeholder={s__('JobForm|Start date')}
  />
);
